import React from 'react'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'
import Tag from '../Tag'

type ItemsStatusTagProps = {
  status?: any
  className?: string
}

const ItemsStatusTag = ({ status, className }: ItemsStatusTagProps) => {
  const { t } = useTranslation()
  const color = () => {
    return (
      {
        analysis: '#BF6827',
        disclosed: '#63B288',
        replied: '#1A3A60'
      }[status] || 'Unknown'
    )
  }

  const getStatusLabel = (status: string): string => {
    return (
      {
        analysis: 'Aguardando Correção',
        disclosed: 'Divulgado',
        replied: 'Corrigido'
      }[status] || 'Unknown'
    )
  }
  return (
    <Tag color={color()} className={className}>
      {t(getStatusLabel(status))}
    </Tag>
  )
}

export default styled(ItemsStatusTag)`
  width: auto;
  height: auto;
  margin-right: 1rem;
`
